import { useEffect, useState } from 'react';
import useInBodyApi from '@apis/useInBodyApi';

// 取得量身總覽下拉選項
const useGetInbodyOverviewOptionsState = ({ isFetchOnMount = true } = {}) => {
	const { getInbodyOverviewOptionsApi: doInbodyOverviewOptionsApi } = useInBodyApi();
	const [options, setOptions] = useState([]);
	const [hasEmployeeMeasure, setEmployeeMeasure] = useState(false);

	const getInbodyOverviewOptionsApi = async () => {
		const resp = await doInbodyOverviewOptionsApi();
		if (resp) {
			setOptions(resp.measureReferenceTypeOptions);
			setEmployeeMeasure(resp.useEmployeeMeasure);
		}
	};

	useEffect(
		() => {
			let isMounted = true;
			if (isFetchOnMount) {
				(async () => {
					const resp = await doInbodyOverviewOptionsApi();
					if (isMounted && resp) {
						setOptions(resp.measureReferenceTypeOptions);
						setEmployeeMeasure(resp.useEmployeeMeasure);
					}
				})();
			}
			return () => {
				isMounted = false;
			};
		},
		// eslint-disable-next-line
		[isFetchOnMount]
	);

	return { options, hasEmployeeMeasure, getInbodyOverviewOptionsApi };
};

export default useGetInbodyOverviewOptionsState;
